import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConvexProvider } from 'convex/react'
import App from './App.tsx'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import theme from './theme'
import { convexClient } from './config/convex'

// Limpiar almacenamiento legacy de Firebase (ya no se usa)
const limpiarFirebaseStorages = () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('firebase') || key.includes('firestore')) &&
        key !== 'authToken' && key !== 'currentUser' && key !== 'lastActivity' && key !== 'lastDbCheck') {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => {
    console.log(`Eliminando clave de localStorage: ${key}`);
    localStorage.removeItem(key);
  });
  
  // 2. Intentar eliminar IndexedDB relacionados con Firebase
  const dbNames = [
    'firebaseLocalStorageDb',
    'firestore',
    'firebase-installations-database',
    'firebase-messaging-database',
    'firebase-auth',
    'firebase-auth-state',
    'firebase-remote-config'
  ];
  
  dbNames.forEach(dbName => {
    try {
      const req = indexedDB.deleteDatabase(dbName);
      req.onsuccess = () => console.log(`Base de datos ${dbName} eliminada correctamente`);
      req.onerror = () => console.error(`Error al eliminar la base de datos ${dbName}`);
    } catch (e) {
      console.error(`Error al intentar eliminar ${dbName}:`, e);
    }
  });
  
  // 3. Limpiar sessionStorage (EXCEPTO nuestras flags de navegación)
  const sessionKeysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && (
      key.includes('firebase') || 
      key.includes('firestore')
    ) &&
    // NO eliminar nuestras flags de navegación
    key !== 'isNavigating' &&
    key !== 'pageLoadTime'
    ) {
      sessionKeysToRemove.push(key);
    }
  }
  
  sessionKeysToRemove.forEach(key => {
    console.log(`Eliminando clave de sessionStorage: ${key}`);
    sessionStorage.removeItem(key);
  });
  
  // 4. Limpiar cookies relacionadas con Firebase
  document.cookie.split(';').forEach(cookie => {
    const [name] = cookie.trim().split('=');
    if (name && (
      name.includes('firebase') || 
      name.includes('firestore') ||
      name.includes('auth')
    )) {
      console.log(`Eliminando cookie: ${name}`);
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
  
}

if (typeof window !== 'undefined') {
  limpiarFirebaseStorages();
  sessionStorage.setItem('isNavigating', 'true');
  setTimeout(() => sessionStorage.setItem('isNavigating', 'false'), 3000);
}

import './config/index'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config?.initialColorMode} />
        <ConvexProvider client={convexClient}>
          <App />
        </ConvexProvider>
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
